import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const BadPhoneNumberError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="bad-phone-number-error" severity="error">
            {t('formErrors.badPhoneNumberError.provideAnotherNumber')}
        </Alert>
    );
};
